module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "fxt-template-layout10"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-12 fxt-bg-img",
    attrs: {
      "md6": "",
      "data-bg-image": "../../../static/img/bg14-l.jpg"
    }
  }, [_c('div', {
    staticClass: "fxt-header"
  }, [_c('div', [_c('h1', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.analyst')) + " ")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "black--text"
  }, [_vm._v(_vm._s(_vm.$t('header.paidTitle')))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "col-12 fxt-bg-color",
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "fxt-content"
  }, [_c('div', {
    staticClass: "fxt-form"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("register.create")))]), _vm._v(" "), _c('v-form', {
    ref: "registrationForm",
    staticClass: "mt-5",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-3",
    attrs: {
      "rules": _vm.regEmailRules,
      "label": _vm.$t('register.email'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "regEmail", $$v)
      },
      expression: "registrationForm.regEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.userNameRules,
      "label": _vm.$t('register.username'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "userName", $$v)
      },
      expression: "registrationForm.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-3",
    attrs: {
      "type": "password",
      "rules": _vm.passWordRules,
      "label": _vm.$t('register.password'),
      "required": ""
    },
    model: {
      value: (_vm.passwordForm.passWord),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "passWord", $$v)
      },
      expression: "passwordForm.passWord"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "password",
      "rules": _vm.repassWordRules,
      "label": _vm.$t('register.confirmationPassword'),
      "required": ""
    },
    model: {
      value: (_vm.passwordForm.repassWord),
      callback: function($$v) {
        _vm.$set(_vm.passwordForm, "repassWord", $$v)
      },
      expression: "passwordForm.repassWord"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('register.invitationCode'),
      "required": ""
    },
    model: {
      value: (_vm.registrationForm.fillInvitationCode),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "fillInvitationCode", $$v)
      },
      expression: "registrationForm.fillInvitationCode"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "rules": _vm.agreedRules
    },
    model: {
      value: (_vm.registrationForm.agreed),
      callback: function($$v) {
        _vm.$set(_vm.registrationForm, "agreed", $$v)
      },
      expression: "registrationForm.agreed"
    }
  }, [_c('div', {
    staticClass: "font-14",
    attrs: {
      "slot": "label"
    },
    on: {
      "click": function($event) {
        _vm.termsModal = true
      }
    },
    slot: "label"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("register.agree")) + "\n                        "), _c('span', {
    staticClass: "primary--text pointer font-14"
  }, [_vm._v("\n                          <<" + _vm._s(_vm.$t("register.terms")) + ">>\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex text-xs-left mt-3"
  }, [_c('v-btn', {
    staticClass: "primary ml-0",
    attrs: {
      "medium": "",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("register.signUp")))]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "medium": "",
      "dark": ""
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v(_vm._s(_vm.$t("register.reset")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-5 fxt-footer font-14"
  }, [_vm._v("\n                      Already a Account?\n                      "), _c('span', {
    staticClass: "primary--text pointer mr-2",
    on: {
      "click": _vm.gotoLogin
    }
  }, [_vm._v(_vm._s(_vm.$t("header.login")))])])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "80%",
      "title": _vm.$t('serviceTerms.title'),
      "ok-text": "OK",
      "cancel-text": "Cancel"
    },
    on: {
      "on-ok": _vm.agreeTerms
    },
    model: {
      value: (_vm.termsModal),
      callback: function($$v) {
        _vm.termsModal = $$v
      },
      expression: "termsModal"
    }
  }, [_c('app-terms')], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.sendEmailModal),
      callback: function($$v) {
        _vm.sendEmailModal = $$v
      },
      expression: "sendEmailModal"
    }
  }, [_c('div', {
    staticClass: "text-center h4 fw-bold mt-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("register.noActivatedMessage")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("register.sendEmailMessage")))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": _vm.closeSendEmailModal
    }
  }, [_vm._v(_vm._s(_vm.$t("common.no")))]), _vm._v(" "), _c('Button', {
    staticClass: "text-white primary",
    on: {
      "click": _vm.sendActivationEmail
    }
  }, [_vm._v(_vm._s(_vm.$t("common.yes")))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "fxt-footer"
  }, [_c('ul', {
    staticClass: "fxt-socials"
  }, [_c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBots_",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-twitter fxt-transformY-50 fxt-transition-delay-7"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/ioBotsPro",
      "title": "twitter"
    }
  }, [_c('i', {
    staticClass: "fab fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fxt-linkedin fxt-transformY-50 fxt-transition-delay-9"
  }, [_c('a', {
    attrs: {
      "href": "https://t.me/iob_llc",
      "title": "Telegram"
    }
  }, [_c('i', {
    staticClass: "fab fa-telegram-plane"
  })])])])])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a99db95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Register.vue
// module id = 452
// module chunks = 0